import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BdbRequest, BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';
import { Observable } from 'rxjs/Observable';
import { SessionStorageKeysEnum } from '../models/session-storage-keys-enum';
import { IDataToReport } from './models/IDataToReport';
import { ChannelService } from './channel.service';
import { ProductsEnum } from '../enums/products-enum';
import { ReportRequestEvent } from '../models/report-event-request.model';
import { SandboxRequestService } from './sandbox/sandbox-request.service';
import { BdbHeadersModel } from '../models/bdb-headers.model';
import { CustomLogger } from '@npm-bbta/bbog-sg-frontend-logs-lib';

const logger = new CustomLogger('EventsService', 'blue');

@Injectable()
export class EventsService {
    private readonly OFFICE_CHANNEL = 'OFFICE';
    private readonly CENTRALES = 'consultaCentrales';
    private readonly PARTICIPANT_RESULT = 'ACTIVE';
    private readonly AUTHENTICATION_FACTOR = '1';
    bdbEventsService: any;
    bdbSessionStrgService: any;

    constructor(
        private readonly bdbRquest: BdbRequest,
        private readonly sessionStorageService: BdbSessionStrgService,
        private readonly channelService: ChannelService,
        private readonly sandbox: SandboxRequestService,
    ) { }

    async reportEvent(eventName: string, status: any, eventResult: string, hand: any, finger: any, olimpiaResult: any) {
        try {
            let reportRequest = this.getBodyRnecEvent(eventName, status, eventResult, hand, finger, olimpiaResult);
            logger.log("reportRequest", reportRequest)
            const urlToSandbox = `${environment.sandboxV3Domain}/rnec/V2/report-biometric-authentication-event`;
            const response = await this.requestPostRencWithSandboxV3(reportRequest, urlToSandbox);
            return {
                body: response.body,
                _body: JSON.stringify(response.body),
                status: response.status
            }
        } catch (error) {
            logger.error('Error report Event -->', error)
            return {
                body: '',
                _body: '',
                status: 400
            }
        }
    }

    getBodyRnecEvent(eventName: string, status: any, eventResult: string, hand: any, finger: any, olimpiaResult: any): ReportRequestEvent {
        let latitud;
        let longitud;
        let hits = 0;
        if (olimpiaResult && olimpiaResult.Latitud && olimpiaResult.Longitud){
            latitud = olimpiaResult.Latitud;
            longitud = olimpiaResult.Longitud;
        }
        if (olimpiaResult && olimpiaResult.biometrias) {
            let hitsFull = olimpiaResult.biometrias.filter(
                element => (element.resultado && element.resultado.toUpperCase() === 'HIT') ||
                 (element.error && element.error.toUpperCase() === 'HIT'));
            hits = hitsFull.length;
        }
        const site = this.sessionStorageService.get(SessionStorageKeysEnum.SITE)
        const appName = ProductsEnum[site].apiName;
        const journey = this.sessionStorageService.get(SessionStorageKeysEnum.JOURNEY);
        const privateIp = this.sessionStorageService.get(SessionStorageKeysEnum.PRIVATE_IP);
        const product = ProductsEnum[site].name;
        const hardware = this.sessionStorageService.get(SessionStorageKeysEnum.HARDWARE);
        const specificProductInfoUuid = this.sessionStorageService.get(SessionStorageKeysEnum.SPECIFIC_PRODUCT_INFO_UUID);
        const provider = eventName === 'acceptTermsAuth' ? 'Contrato Regulación RNEC' : !!hardware ? hardware === 'new' ? 'P80' : 'Samsung' : '';
        latitud = latitud ? latitud.replace(",", ".") : 0;
        longitud = longitud ? latitud.replace(",", ".") : 0;
        const statusR = status.slice(0, 90);
        return {
            appName: appName,
            documentNumber: this.sessionStorageService.get(SessionStorageKeysEnum.IDENTITY_NUMBER),
            documentType: 'C',
            eventName: eventName,
            resultEvent: statusR,
            eventResult: eventResult,
            journey,
            latitud,
            longitud,
            ip: privateIp,
            officeCode: this.sessionStorageService.get(SessionStorageKeysEnum.OFFICE_CODE),
            mediumType: this.sessionStorageService.get(SessionStorageKeysEnum.MEDIUM_TYPE),
            finger: finger,
            hand: '' + hand,
            expdate: this.sessionStorageService.get(SessionStorageKeysEnum.EXPDATE),
            product,
            sellerIdentityType: this.sessionStorageService.get(SessionStorageKeysEnum.SELLER_IDENTITY_TYPE),
            sellerDocumentNumber: this.sessionStorageService.get(SessionStorageKeysEnum.SELLER_IDENTITY_NUMBER),
            sellerUsername: this.sessionStorageService.get(SessionStorageKeysEnum.SELLER_USER_NAME),
            sellerIdentityNumberLdap: this.sessionStorageService.get(SessionStorageKeysEnum.SELLER_IDENTITY_NUMBER_LDAP),
            sellerIdentityNumberFair: this.sessionStorageService.get(SessionStorageKeysEnum.SELLER_IDENTITY_NUMBER_FAIR),
            specificProductInfoUuid,
            candidate: this.sessionStorageService.get(SessionStorageKeysEnum.CANDIDATE),
            uuidAuth: this.sessionStorageService.get(SessionStorageKeysEnum.UUID_AUTH),
            provider,
            channel: this.channelService.getChannel(),
            olimpiaResult,
            hits: hits,
        }
    }

    public async requestPostRencWithSandboxV3(body: any, url: string) {
        const documentNumber = this.sessionStorageService.get(SessionStorageKeysEnum.IDENTITY_NUMBER);
        const documentType = this.sessionStorageService.get(SessionStorageKeysEnum.IDENTITY_TYPE);
        const newHeaders =
            this.getStandardizedHeadersForSandboxv3(documentType, documentNumber);
        Object.assign(newHeaders, { 'content-type': 'application/json' });
        delete newHeaders['Content-Type'];
        return await this.sandbox.requestPostSandbox(url, body, newHeaders);
    }

    getStandardizedHeadersForSandboxv3(identityType: string, identityNumber: string): BdbHeadersModel {
        const network = this.sessionStorageService.get(SessionStorageKeysEnum.PUBLIC_IP);
        const site = this.sessionStorageService.get(SessionStorageKeysEnum.SITE);
        const rqUuid = this.sessionStorageService.get(SessionStorageKeysEnum.UUID_AUTH);
        const xname = 'Seguridad';
        return {
            'X-Channel': 'channel',
            'X-CustIdentType': identityType,
            'X-CustIdentNum': identityNumber,
            'X-IPAddr': network,
            'X-CompanyId': '001',
            'X-Name': xname,
            'X-RqUID': rqUuid,
            'X-User-Agent': navigator.userAgent
        };
    }
    prepareEventAcceptance(typeAuth: any) {
        const message = {
            'privateIp': this.sessionStorageService.get('ip'),
            'idNumber': this.sessionStorageService.get('identityNumber'),
            'channel': this.OFFICE_CHANNEL,
            'userType': this.sessionStorageService.get(SessionStorageKeysEnum.CUSTOMER_STATE),
            'productId': this.sessionStorageService.get(SessionStorageKeysEnum.SITE),
            'acceptanceType': this.CENTRALES,
            'typeAuthentication': typeAuth
        }
        const encoding = btoa(JSON.stringify(message));
        const request = {
            messageType: 'bdb-user-acceptance',
            messageContent: encoding
        };
        return request;
    }

    sendEvent(jsonData: any): Observable<any> {
        return this.bdbRquest.requestPost(environment.apiEndpointEventsReg + 'publish', jsonData).map(response => {
            return response;
        });
    }

    getInfoDataToReport(): IDataToReport {
        const privateIp = this.sessionStorageService.get(SessionStorageKeysEnum.PRIVATE_IP);
        const rqUuid = this.sessionStorageService.get(SessionStorageKeysEnum.UUID_AUTH);
        const site = this.sessionStorageService.get(SessionStorageKeysEnum.SITE);
        const appName = ProductsEnum[site] ? ProductsEnum[site].apiName : '';
        const product = ProductsEnum[site].name;
        const journey = !!this.sessionStorageService.get(SessionStorageKeysEnum.JOURNEY) ?
            this.sessionStorageService.get(SessionStorageKeysEnum.JOURNEY) : 'FlujoWeb';
        const specificProductInfoUuid = this.sessionStorageService.get(SessionStorageKeysEnum.SPECIFIC_PRODUCT_INFO_UUID);
        const specificProductInfo = this.sessionStorageService.get(SessionStorageKeysEnum.SPECIFIC_PRODUCT_INFO);
        const hardware = this.sessionStorageService.get(SessionStorageKeysEnum.HARDWARE);
        const provider = !!hardware ? hardware === 'new' ? 'P80' : 'Samsung' : '';
        return {
            AppName: appName,
            journey: journey,
            channel: this.channelService.getChannel(),
            factor: this.AUTHENTICATION_FACTOR,
            privateIp,
            product: product,
            provider: provider,
            participantResult: this.PARTICIPANT_RESULT,
            result: '200',
            specificProductInfoUuid: specificProductInfoUuid,
            specificProductInfo: specificProductInfo,
            sellerIdentityType: this.sessionStorageService.get(SessionStorageKeysEnum.SELLER_IDENTITY_TYPE),
            sellerDocumentNumber: this.sessionStorageService.get(SessionStorageKeysEnum.SELLER_IDENTITY_NUMBER),
            sellerUsername: this.sessionStorageService.get(SessionStorageKeysEnum.SELLER_USER_NAME),
            sellerIdentityNumberLdap: this.sessionStorageService.get(SessionStorageKeysEnum.SELLER_IDENTITY_NUMBER_LDAP),
            uuidAuth: rqUuid
        };
    }


}



// WEBPACK FOOTER //
// ./src/app/shared/bdb-event.service.ts